interface File {
  id: number;
  name: string;
  reference_number: string;
  file_extension: string;
  url: string;
}

interface AttachmentBucket {
  id: number;
  is_active: boolean;
  is_mandatory: boolean;
  is_mandatory_on_cancelation: boolean;
  is_mandatory_on_intermediate_invoice: boolean;
  bucket_name: string;
  bucket_type: string;
  freight_modes: string[];
  availability: number;
  ordering_on_approved_invoice: number;
  company: number;
  shipper_locations: any[];
}

interface BucketAttachment {
  file: File;
  attachment_bucket: AttachmentBucket;
}

interface BucketMetadata {
  id: number;
  is_mandatory: boolean;
  is_mandatory_on_intermediate_invoice: boolean;
  bucket_name: string;
  is_mandatory_on_cancelation: boolean;
}

const findMissingMandatoryBuckets = (uploadedAttachments: any, bucketRequirements: any, invoiceType: string) => {
  // Extract bucket names from uploaded attachments
  const uploadedBucketNames = uploadedAttachments.bucket_attachments.map(
    (attachment: BucketAttachment) => attachment.attachment_bucket.bucket_name,
  );

  // Determine which buckets are mandatory
  const mandatoryBuckets = bucketRequirements?.invoice_attachment_bucket
    .filter((bucket: BucketMetadata) =>
      invoiceType === "intermediate_invoice" ? bucket.is_mandatory_on_intermediate_invoice : bucket.is_mandatory,
    )
    .map((bucket: BucketMetadata) => bucket.bucket_name);

  // Check which mandatory buckets are missing
  const missingMandatoryBuckets = mandatoryBuckets.filter(
    (bucketName: string) => !uploadedBucketNames.includes(bucketName) && bucketName !== "Other",
  );

  return missingMandatoryBuckets;
};

export default findMissingMandatoryBuckets;
